import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

import LocalizedMessage, { localizeMessage } from '../../../../components/LocalizedMessage';
import URLFiltersHoc, { Props } from '../../../../components/URLFiltersHoc';
import Breadcrumbs from '../../../../components/Breadcrumbs';
import TableList from '../../../../components/TableList';
import API from '../../../../api';
import { Locale } from 'types';

interface IOwnProps {
  lang: Locale;
}

interface IState {
  dataList: any[],
  dataListTotal: number;
  isLoading: boolean;
}

class Countries extends PureComponent<IOwnProps & Props, IState> {
  state: IState = {
    dataList: [],
    dataListTotal: 1,
    isLoading: false

    // country: ''
  };

  mounted = false;
  refreshListTimer = 0;
  refreshListTimerDelay = 500;
  _form = null;

  componentDidMount () {
    this.mounted = true;
    this.refreshList();
  }

  componentDidUpdate (prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.refreshList();
    }
  }

  componentWillUnmount () {
    this.mounted = false;
    clearTimeout(this.refreshListTimer);
  }

  refreshList () {
    clearTimeout(this.refreshListTimer);
    const { currentPage, currentSort, max } = this.props.filters;
    const dataListRequest = {
      page: currentPage,
      order: currentSort,
      max,
    };

    this.refreshListTimer = window.setTimeout(async () => {
      this.setState({ isLoading: true });

      const dataList = await API.countries.list(dataListRequest);

      if (!this.mounted) {
        return;
      }

      this.setState({
        dataList: dataList.items,
        dataListTotal: dataList.total,
        isLoading: false
      });
    }, this.refreshListTimerDelay);
  }

  getBreadcrumbs () {
    return [
      {
        title: <LocalizedMessage id='home' />,
        link: '/app'
      },
      {
        title: <LocalizedMessage id='menu.dictionaries.countries' />,
        link: '/app/dictionaries/countries'
      }
    ];
  }

  setFormRef = (ref) => {
    this._form = ref;
  };

  /* handleInputChange = (e) => {
    const value = e.target.type === 'file' ? e.target.files[0] : e.target.value;

    this.setState({
      [e.target.name]: value
    });
  }; */

  // resetClick = () => {
  //   this._form.reset();
  //
  //   this.setState({
  //     country: null
  //   });
  // };

  // onSubmit = async (e) => {
  //   e.preventDefault();
  //
  //   const {
  //     country
  //   } = this.state;
  //
  //   if (!country || !country.length) {
  //     return;
  //   }
  //
  //   try {
  //     await API.countries.create({
  //       name: country
  //     });
  //
  //     Alert.success(localizeMessage({id: 'countries-dictionary.successfullySent'}));
  //
  //     this.resetClick();
  //
  //     this.refreshList();
  //   } catch (error) {
  //     console.error(error);
  //
  //     Alert.warn(localizeMessage({id: 'countries-dictionary.errorSending'}));
  //   }
  // };

  render () {
    const { lang, onUpdateSort, onUpdatePage, filters } = this.props;
    const {
      // country,
      dataList,
      dataListTotal,
      isLoading
    } = this.state;

    const countryFieldName = lang === 'en' ? 'nameEn' : 'name';

    return (
      <>
        <LocalizedMessage
          id='site.title.dictionaries.countries'
        >
          {localizedMessage => (
            <>
              <Helmet
                title={localizedMessage}
              />
              <Breadcrumbs
                title={localizedMessage}
                data={this.getBreadcrumbs()}
              />
            </>
          )}
        </LocalizedMessage>

        <div className='wrapper wrapper-content'>
          {/*
          <div className='row'>
            <div className='col-lg-12'>
              <div className='ibox float-e-margins'>
                <div className='ibox-content'>
                  <form
                    ref={this.setFormRef}
                    onSubmit={this.onSubmit}
                  >
                    <div className='form-horizontal'>
                      <div className='form-group'>
                        <label className='col-lg-2 control-label'>
                          <LocalizedMessage id='countries-dictionary.country.label' />
                        </label>

                        <div className='col-lg-10'>
                          <LocalizedMessage id='countries-dictionary.country.placeholder'>
                            {localizedPlaceholder => (
                              <input
                                type='text'
                                className='form-control'
                                name='country'
                                value={country}
                                placeholder={localizedPlaceholder}
                                onChange={this.handleInputChange}
                              />
                            )}
                          </LocalizedMessage>
                        </div>
                      </div>

                      <div className='hr-line-dashed' />

                      <div className='form-group'>
                        <div className='col-lg-2' />
                        <div className='col-lg-10'>
                          <button
                            className='btn btn-white'
                            onClick={this.resetClick}
                          >
                            <span><LocalizedMessage id='reset' /></span>
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type='submit'
                            className='btn btn-primary'
                            onClick={this.onSubmit}
                            disabled={!country || !country.length}
                          >
                            <>
                              <i className='fa fa-chevron-down fa-lg' />
                              <span><LocalizedMessage id='save' /></span>
                            </>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          */}

          <div className='row'>
            <div className='col-lg-12'>
              <div className='ibox float-e-margins'>
                <div className='ibox-content'>
                  <div className='table-responsive'>
                    <TableList
                      currentPage={filters.currentPage}
                      currentSort={filters.currentSort}
                      totalItems={dataListTotal}
                      itemsCountPerPage={filters.max}
                      onUpdateSort={onUpdateSort}
                      onUpdatePage={onUpdatePage}
                      isLoading={isLoading}
                      head={[
                        {
                          label: localizeMessage({ id: 'id' }),
                          sort: 'id'
                        },
                        {
                          label: localizeMessage({ id: 'country' }),
                          sort: 'name'
                        }
                      ]}
                    >
                      {
                        dataList.map((row, rowIndex) => (
                          <tr key={rowIndex + '_countries'}>
                            <td>{row.id}</td>
                            <td>{row[countryFieldName]}</td>
                          </tr>
                        ))
                      }
                    </TableList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default URLFiltersHoc(Countries, 'id');
